<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('settings.title') }}</h3>
        </div>

        <div class="list" v-if="(isLoaded)">
            <div>{{ $t('settings.header')}}</div>
            <ul>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220))">
                    <!-- フォルシング開始手続き画面(規約)へ遷移 -->
                    <!-- フォルシング契約の状態：未完了 -->
                    <span v-if="(!this.latestMembershipFee)">
                        <router-link class="nav-link"
                                    :class="{disabled: isMembershipFeePayable()}"
                                    :to="{ name: 'MembershipFeePolicy' }">
                            {{ $t('payment.messages.title') }}
                        </router-link>
                    </span>
                    <!-- フォルシング開始手続き画面(HEC数)へ遷移 -->
                    <!-- フォルシング契約の状態：次回契約受付中 -->
                    <span v-else-if="(this.latestMembershipFee && !this.latestMembershipFee.is_active)">
                        <!-- メンバータイプ詳細：プレミアムメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日より前） -->
                        <!-- フォルシング更新可能フラグ：更新可能日を過ぎているので更新可能 -->
                        <div v-if="((this.membertypeDetail == 'PREMIUM_MEMBER' ||
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_BELOW_CONTRACT') &&
                                    this.forthingRenewalFlg)">
                            <router-link class="nav-link"
                                        :class="{disabled: isMembershipFeePayable()}"
                                        :to="{ name: 'MembershipFeeConditionRenewal' }">
                                {{ $t('payment.messages.title') }}
                            </router-link>
                        </div>
                        <!-- メンバータイプ詳細：プレミアムメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日より前） -->
                        <!-- フォルシング更新可能フラグ：更新可能日より前なので更新不可 -->
                        <div v-else-if="((this.membertypeDetail == 'PREMIUM_MEMBER' ||
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_BELOW_CONTRACT') &&
                                    !this.forthingRenewalFlg)">
                            <router-link class="nav-link"
                                        :class="{disabled: isDisabledLink()}"
                                        :to="{ name: 'MembershipFeeConditionRenewal' }">
                                {{ $t('payment.messages.title') }}
                            </router-link>
                        </div>
                        <!-- メンバータイプ詳細：サポートメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日以後） -->
                        <!-- フォルシング更新可能フラグ：更新可能日を過ぎているので更新可能 -->
                        <div v-else-if="((this.membertypeDetail == 'SUPPORT_MEMBER' ||
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_OR_OVER_CONTRACT') &&
                                    this.forthingRenewalFlg)">
                                <router-link class="nav-link"
                                        :class="{disabled: isMembershipFeePayable()}"
                                        :to="{ name: 'MembershipFeeConditionRenewal' }">
                                {{ $t('payment.messages.title') }}
                            </router-link>
                        </div>
                        <!-- メンバータイプ詳細：サポートメンバー、アップグレードしたプレミアムメンバー（初回払い出し日が契約終了日以後） -->
                        <!-- フォルシング更新可能フラグ：更新可能日より前なので更新不可 -->
                        <div v-else-if="((this.membertypeDetail == 'SUPPORT_MEMBER' ||
                                    this.membertypeDetail == 'UPGRADE_PREMIUM_MEMBER_PAYOUT_OR_OVER_CONTRACT') &&
                                    !this.forthingRenewalFlg)">
                            <router-link class="nav-link"
                                        :class="{disabled: isDisabledLink()}"
                                        :to="{ name: 'MembershipFeeConditionRenewal' }">
                                {{ $t('payment.messages.title') }}
                            </router-link>
                        </div>
                    </span>
                    <!-- データ不整合 -->
                    <span v-else>
                        <router-link class="nav-link"
                                    :class="{disabled: isDisabledLink()}"
                                    :to="{ name: 'MembershipFeePolicy' }">
                            {{ $t('payment.messages.title') }}
                        </router-link>
                    </span>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220))">
                    <router-link v-if="(this.isLoaded)" class="nav-link" to="/kyc-settings"
                                 :class="{disabled: this.kycApproval}">
                        {{ $t('kyc.settings.title') }}
                    </router-link>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220))">
                    <router-link class="nav-link" to="/activation">
                        {{ $t('settings.force.activate') }}
                    </router-link>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220))">
                    <!-- HEC Saving申し込み -->
                    <router-link class="nav-link"
                                :class="{disabled: isFeeHecSavingApplication()}"
                                :to="{ name: 'hecSavingApplication' }">
                        {{ $t('hecSaving.messages.title') }}
                    </router-link>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220) ||
                    (! isChild && isMembertype == 2100))">
                    <router-link class="nav-link" to="/account/edit-profile">
                        {{ $t('settings.account.info') }}
                    </router-link>
                </li>
                <li>
                    <router-link class="nav-link" to="/account/reset-password">
                        {{ $t('settings.account.resetPassword') }}
                    </router-link>
                </li>
                <li>
                    <router-link class="nav-link" to="/account/2sa">
                        {{ $t('settings.account.2sa') }}
                    </router-link>
                </li>
                <li v-if="((! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220) ||
                    (! isChild && isMembertype == 2100))">
                    <router-link class="nav-link" to="/account/change-mail-request">
                        {{ $t('settings.account.mail') }}
                    </router-link>
                </li>
                <li v-if="(! isChild && isMembertype == 1200) ||
                    (! isChild && isMembertype == 1210) ||
                    (! isChild && isMembertype == 1220)">
                    <router-link class="nav-link" to="/messages">
                        {{ $t('settings.account.status') }}
                    </router-link>
                </li>
            </ul>

            <div v-if="((! isChild && isMembertype == 1200) ||
                (! isChild && isMembertype == 1210) ||
                (! isChild && isMembertype == 1220) ||
                (! isChild && isMembertype == 2100))">
                <div>{{ $t('account.child.title') }}</div>
                <ul>
                    <li>
                        <router-link class="nav-link" to="/account/sub-account">
                            {{ $t('account.child.manage') }}
                        </router-link>
                    </li>
                </ul>
            </div>

            <div v-if="(! isChild)">
                <div>{{ $t('settings.token.title') }}</div>
                <ul>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'forthing-detail' }">{{ $t('settings.forthing.detail') }}</router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'historyOfForthingAgreement' }">{{ $t('settings.forthingAgreement.history') }}</router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" :to="{ name: 'exbonus-history' }">{{ $t('settings.exBonus.history') }}</router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220) ||
                        (! isChild && isMembertype == 2100)">
                        <router-link class="nav-link" :to="{ name: 'token-detail' }">{{ $t('settings.token.detail') }}</router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <router-link class="nav-link" to="/hec-saving/automatic-remittance"
                            :class="{disabled: this.is_hecsaving_applied}">
                            {{ $t('settings.hecsaving.title') }}
                        </router-link>
                    </li>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220) ||
                        (! isChild && isMembertype == 2100)">
                        <router-link class="nav-link" :to="{ name: 'tokenCsv' }">{{ $t('settings.walletTransactionHistory.title') }}</router-link>
                    </li>
                </ul>
            </div>
            <div v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                <div>{{ $t('settings.hecstaking.title') }}</div>
                <ul>
                    <li v-if="(! isChild && isMembertype == 1200) ||
                        (! isChild && isMembertype == 1210) ||
                        (! isChild && isMembertype == 1220)">
                        <a v-bind:href="this.hec_staking_url" class="nav-link">{{ $t('settings.hecstaking.detail') }}</a>
                    </li>
                    <div v-if="(this.display)">
                        <li v-if="(! isChild && isMembertype == 1200) ||
                            (! isChild && isMembertype == 1210) ||
                            (! isChild && isMembertype == 1220)">
                            <a v-bind:href="this.metax_pro_url" class="nav-link">{{ $t('settings.metaxPro.detail') }}</a>
                        </li>
                    </div>
                </ul>
            </div>
            <!-- フォルシング親会員の場合 リンク表示 -->
            <div v-if="(! isChild && isMembertype == 2100) ||
                    (! isChild && isMembertype == 2200) ">
                <div>{{ $t('settings.hecsavingBasic.title') }}</div>
                <ul>
                    <li v-if="(! isChild && isMembertype == 2100) ||
                        (! isChild && isMembertype == 2200) ">
                        <a v-bind:href="this.hec_staking_url" class="nav-link">{{ $t('settings.hecsavingBasic.detail') }}</a>
                    </li>
                    <div v-if="(this.display)">
                        <li v-if="(! isChild && isMembertype == 2100) ||
                            (! isChild && isMembertype == 2200) ">
                            <a v-bind:href="this.metax_pro_url" class="nav-link">{{ $t('settings.metaxPro.detail') }}</a>
                        </li>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "../services/UserService";
    import { KYC_SETTINGS_APPROVAL } from '../utils/Const';
    import kycService from '../services/KycService';

    export default {
        name: 'settings',

        data() {
            return {
                isChild: true,
                isLoaded: false,
                latestMembershipFee: undefined,
                isMembertype: 0,
                kycStatus: undefined,
                kycApproval: '',
                hec_card_url: process.env.MIX_HEC_CARD_URL,
                hec_staking_url: process.env.MIX_HEC_STAKING_URL,
                metax_pro_url: process.env.MIX_METAX_PRO_URL,
                notForceClubMember: false,
                is_hecsaving_applied: true,
                is_hecsaving_applied_disabled: true,
                membertypeDetail: undefined,
                forthingRenewalFlg: false,
                precedenceEmailEnv: '',
                display: false,
                service: '',
                user_id: '',
                type: '',
            }
        },

        async updated(){

            if(Number(this.kycService) == KYC_SETTINGS_APPROVAL){
                this.kycApproval = true
            }else{
                this.kycApproval = false
            }

        },

        created() {
            this.sessionOrderClear();
            this.fetchUserFrontendData()
        },

        methods: {
            async submit() {
                const data = (await UserService.getUserFrontendData()).data;
                this.service = "aube";
                this.user_id = data.external_user_id;
                this.type = (await UserService.getType(data.email)).data.vip_rank;
                this.$nextTick(function() {
                    document.atemCard.submit();
                });

            },
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isMembertype = data.member_type_id
                this.isChild = data.is_child

                if(process.env.MIX_PRECEDENCE_EMAIL != undefined){
                    this.precedenceEmailEnv = process.env.MIX_PRECEDENCE_EMAIL.split(',')
                    if (this.precedenceEmailEnv.includes(data.email)) {
                        if((! this.isChild && this.isMembertype == 2100) || (! this.isChild && this.isMembertype == 2200)){
                            this.type = (await UserService.getType(data.email)).data.vip_rank
                            if(this.type >= 2){
                                this.display = true
                            }
                        }else{
                            this.display = true
                        }
                    }
                }else{
                    if((! this.isChild && this.isMembertype == 2100) || (! this.isChild && this.isMembertype == 2200)){
                        this.type = (await UserService.getType(data.email)).data.vip_rank
                        if(this.type >= 2){
                            this.display = true
                        }
                    }else{
                        this.display = true
                    }
                }

                const forceClubData = await UserService.getForceClubInfoData(); //ForceClub退会、停止情報取得

                if (data.is_hecsaving_applied) {
                    // is_hecsaving_appliedがtrueの場合はリンク活性化
                    this.is_hecsaving_applied = false;
                } else {
                    // is_hecsaving_appliedがfalseの場合はリンク非活性化
                    this.is_hecsaving_applied = true;
                }

                try{
                    const result = (await kycService.getStatus()).data
                    this.kycService = result.status
                }catch{
                    this.kycApproval = true
                }

                this.is_hecsaving_applied_disabled = data.is_hecsaving_applied

                this.latestMembershipFee = data.latestMembershipFee;

                this.isChild = data.is_child;

                this.isLoaded = true;

                this.isMembertype = data.member_type_id;

                this.notForceClubMember = forceClubData.data;

                this.membertypeDetail = data.membertypeDetail; //メンバータイプ詳細（プレミアム、サポート、アップグレードメンバー）
                var forthingRenewalDate = Date.parse(data.forthingRenewalDate); //契約更新可能日を日付型に変換
                var nowDate = new Date();//現在日時を取得
                // 現在日時が契約更新可能日を過ぎているか
                if(nowDate > forthingRenewalDate){
                    // 過ぎていれば更新可能フラグを立てる
                    this.forthingRenewalFlg = true;
                }else{
                    this.forthingRenewalFlg = false;
                }

            },
            isMembershipFeePayable() {

                // ForceClubを退会、停止している場合
                if(this.notForceClubMember){
                    return true;
                }
                // HEC Saving申込していない場合
                // フォルシング契約の状態：未完了、完了、次回契約受付中のいずれかの場合
                if(!this.is_hecsaving_applied_disabled){
                    return true;
                }
                // HEC Saving申込している場合
                // フォルシング契約の状態：完了の場合
                else if (this.latestMembershipFee && this.latestMembershipFee.is_active) {
                    return true;
                }
                // HEC Saving申込している場合
                // フォルシング契約の状態：未完了、または次回契約受付中の場合
                return false;
            },
            isDisabledLink() {
                return true;
            },
            sessionOrderClear() {
                sessionStorage.removeItem('formData');
            },
            //HEC Saving申込 状態：完了
            isFeeHecSavingApplication() {
                if(this.is_hecsaving_applied_disabled){
                    return true;
                }
            },
        }
    }
</script>

<style>

</style>
